import { Text } from '@visx/text';
import { Group } from '@visx/group';
import {
  MARKER_FONT_SIZE,
  MARKER_LINE_WIDTH,
  MARKER_PADDING,
  getMarkerBoxWidth,
} from '../utils';

type Props = {
  x: number;
  y: number;
  label: string;
  value: string;
  accentColor: string;
  isFlipped: boolean;
};

export const FairValueHistogramChartMarker = ({
  x,
  y,
  label,
  value,
  accentColor,
  isFlipped,
}: Props) => {
  const { boxWidth, spaceWidth, labelWidth, startPadding } = getMarkerBoxWidth(
    label,
    value
  );
  const boxHeight = MARKER_FONT_SIZE + MARKER_PADDING * 2;

  const getGroupX = () => {
    if (isFlipped) return x - boxWidth;

    return x;
  };

  return (
    <Group>
      <Group top={y} left={getGroupX()}>
        <rect
          x={0}
          y={0}
          width={boxWidth}
          height={boxHeight}
          fill="var(--s-color-surface-3)"
          rx={2}
          ry={2}
        />
        <Text
          x={startPadding}
          y={MARKER_PADDING}
          dy="0.1em"
          verticalAnchor="start"
          fontSize={MARKER_FONT_SIZE}
          className="fill-soft"
        >
          {label}
        </Text>
        <Text
          x={startPadding + spaceWidth + labelWidth}
          y={MARKER_PADDING}
          dy="0.1em"
          verticalAnchor="start"
          fontSize={MARKER_FONT_SIZE}
          className="fill-solid"
        >
          {value}
        </Text>
      </Group>
      <rect
        x={isFlipped ? x - MARKER_LINE_WIDTH : x}
        y={y}
        width={MARKER_LINE_WIDTH}
        height={boxHeight}
        fill={accentColor}
      />
    </Group>
  );
};
